var $a28905d49b59dd1c$exports = {};
$a28905d49b59dd1c$exports = {
    "invalidSelection": (args, formatter)=>`Valitud ${formatter.plural(args.selectedCount, {
            one: `kuup\xe4ev`,
            other: `kuup\xe4evad`
        })} pole saadaval.`
};


export {$a28905d49b59dd1c$exports as default};
//# sourceMappingURL=et-EE.mjs.map
